<!-- eslint-disable -->

<template>
  <div>
    <drawer-vue></drawer-vue>
    <div class="pa-2">
      <v-row v-if="$route.name != 'show'" class="justify-end mt-n12 mb-8"
        ><v-col cols="2" class="d-flex justify-end align-center">
          <v-select
            :readonly="this.adminType == 'branch' ? true : false"
            :items="branches"
            outlined
            item-text="name"
            item-value="id"
            :label="$t('current branch')"
            dense
            rounded
            v-model="Branches.currentBranch"
            @change="setBranch"
          ></v-select>
          <!-- <h4 class="mx-1 primary--text">{{ adminType }}</h4> -->
          <v-icon color="primary" class="mt-n6 mx-1" x-large
            >mdi-source-branch</v-icon
          >
        </v-col></v-row
      >
      <v-fab-transition name="move-left">
        <router-view />
      </v-fab-transition>
    </div>
  </div>
</template>
<script>
import drawerVue from "@/components/drawer.vue";
import { Branches } from "@/store/branches";
export default {
  components: {
    drawerVue,
  },
  data() {
    return {
      Branches,
      branches: [],
    };
  },
  methods: {
    setBranch(e) {
      let test = Branches.tableData.data.find((branch) => branch.id === e);
      Branches.currentBranch = test;
      localStorage.setItem("branch", JSON.stringify(test));
    },
  },
  computed: {
    adminType() {
      return localStorage.getItem("admin_type");
    },
  },

  async mounted() {
    if (this.adminType == "super") {
      await Branches.get();
      this.branches = Branches.tableData.data;
    }
    if (this.adminType == "branch") {
      let branch = JSON.parse(localStorage.getItem("branch"));
      this.branches.push(branch);
      Branches.currentBranch = branch;
    }
  },
  watch: {
    "Branches.currentBranch"() {
      this.branches = Branches.tableData.data;
    },
  },
};
</script>
